import React, { useEffect, useState } from "react";
import { getGraficas } from "../../common/CygniRequests";
import { Typography, List, ListItem, ListItemText } from "@material-ui/core";
import { numberWithCommas, queryPrep } from "../../common/Cygni";
import { CygniLoadingFix } from "../../common/CygniLoading";
import { VisContainer } from "../../common/CygniContainers";

export const TiposNotas = React.memo(({ queries, current }) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    setData(null);

    var tipos = [];
    var resMap = queries.map(async (el, i) => {
      if (
        current.id.includes(-1) ||
        (!current.id.includes(-1) && current.id.includes(el.qry_id))
      ) {
        var res = await getGraficas(
          queryPrep(el.query),
          current.fi.replace(/-/g, "_"),
          current.ff.replace(/-/g, "_"),
          "cygnimoviltipomedio"
        );

        tipos.push({
          query: el.qry_nombre,
          i: res.impreso,
          e: res.electronico,
        });
      }
    });

    // Wait for all requests, and then setState
    Promise.all(resMap).then(() => {
      setData(tipos);
    });
  }, [current, queries]);

  return (
    <VisContainer
      title="Tipos de Medios"
      desc="Tipos de medios en los que se encontraron notas."
      time={data ? true : false}
      showMenu={false}
    >
      {!data && <CygniLoadingFix />}
      {data && !current.id.includes(-1) && current.id.length === 1 && (
        <React.Fragment>
          <Typography
            component="h4"
            variant="h3"
            color="primary"
            align="center"
          >
            {/* <Link
              href="#"
              onClick={() => chartClick(getTipoMedioClaveIntelite("impreso"))}
            > */}
            {data[0].i && numberWithCommas(data[0].i)}
            {/* </Link> */}
          </Typography>
          <Typography component="h5" variant="h5" align="center" gutterBottom>
            Impresos
          </Typography>
          <Typography
            component="h4"
            variant="h3"
            color="primary"
            align="center"
          >
            {/* <Link
              href="#"
              onClick={() =>
                chartClick(getTipoMedioClaveIntelite("electronico"))
              }
            > */}
            {data[0].e && numberWithCommas(data[0].e)}
            {/* </Link> */}
          </Typography>
          <Typography component="h5" variant="h5" align="center">
            Electrónicos
          </Typography>
        </React.Fragment>
      )}
      {data && (current.id.includes(-1) || current.id.length > 1) && (
        <List>
          {data.length > 0 &&
            data.map((el, i) => {
              return (
                <ListItem key={i}>
                  <ListItemText
                    primary={
                      <Typography variant="h6" color="primary">
                        {el.query}
                      </Typography>
                    }
                    secondary={
                      <Typography variant="subtitle1" color="textSecondary">
                        {el.i + " impresos y " + el.e + " electrónicos."}
                      </Typography>
                    }
                  />
                </ListItem>
              );
            })}
        </List>
      )}
    </VisContainer>
  );
});
